import { Route, Routes } from 'react-router-dom';
import Footer from '../Footer/Footer';
import BuySellGetStarted from './BuySellGetStarted';
import BuySellEmailAuth from './/BuySellEmailAuth';
//import BuySellSecureSteps from './/BuySellSecureSteps';
import BuySellMobiAuth from './/BuySellMobiAuth';
import BuySellmobiVerfication from './/BuySellmobiVerfication';
import Blockpass from '../Blockpass/Blockpass';
import RedirectIfSignedIn from '../RedirectIfSignedIn';


const BuySellGetStartedLayout = () => {
    return (
        <>
            <div className='scan-container flex-align-stretch bs_main'>
                {/* Signed-in visitors skip sign-up and its email/SMS code steps;
                    secure-steps (Blockpass KYC) stays open for signed-in users. */}
                <Routes>
                    <Route index element={<RedirectIfSignedIn><BuySellGetStarted /></RedirectIfSignedIn>} />
                    <Route path="email-auth" element={<RedirectIfSignedIn><BuySellEmailAuth /></RedirectIfSignedIn>} />
                    {/* <Route path="secure-steps" element={<BuySellSecureSteps />} /> */}
                    <Route path="secure-steps" element={<Blockpass />} />
                    <Route path="sms-auth" element={<RedirectIfSignedIn><BuySellMobiAuth /></RedirectIfSignedIn>} />
                    <Route path="sms-verify" element={<RedirectIfSignedIn><BuySellmobiVerfication /></RedirectIfSignedIn>} />
                </Routes>
            </div>
            <Footer footerArt="flipWoman" />
        </>
    )
}

export default BuySellGetStartedLayout;